<template>
  <div class="flex flex-row w-screen">
    <div class="w-full">
      <div
        class="mt-3 w-full flex flex-row justify-around content-center"
        id="gallery"
        style="overflow: hidden"
        :key="refreshKey"
      >
        <button class="button my-auto" @click="navigate(false)">&laquo;</button>
        <div class="flex flex-row justify-around w-5/6">
          <ImageComponent
            v-for="(image, index) in displayArray"
            :key="index"
            class="mx-2"
            :style="
              selectedImageID == image.id
                ? 'transform: scale(1.2)'
                : 'opacity:70%'
            "
            style="
              width: 100px;
              height: 100px;
              transition: all 0.5s ease !important;
            "
            @click="selectedImage(index)"
            :url="image.url + '?session=' + session"
            :imageId="image.id"
          />
        </div>
        <button class="button my-auto" @click="navigate(true)">&raquo;</button>
      </div>
      <transition-group name="slide" mode="out-in">
        <OCRComponent
          :selectedImageID="selectedImageID"
          :key="'stage-1'"
          @loading="setLoader($event)"
          @reset="reset()"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import OCRComponent from "../components/OCRComponent.vue";
import ImageComponent from "../components/ImageComponent.vue";

import { routes } from "../router/index";
import router from "../router";
import _ from "lodash";
export default {
  name: "OCRValidation",
  data() {
    return {
      session: this.$store.state.id,
      selectedImageID: null,
      size: null,
      displayArray: [],
      refreshKey: 0,
      indices: [],
    };
  },
  components: {
    ImageComponent,
    OCRComponent,
  },
  created() {
    this.selectedImageID = this.$route.query.selectedImageID;
    this.images = this.$store.state.batchImages;
    this.size = this.images.length;
    this.index = this.images.findIndex((image) => {
      return image.id == this.selectedImageID;
    });
    this.setImages();
  },
  methods: {
    setImages() {
      this.indices = [];
      if (this.index >= this.size) {
        this.index = 0;
      } else if (this.index < 0) {
        this.index = this.size - 1;
      }
      this.indices = [this.index];
      this.selectedImageID = this.images[this.index].id;
      for (var i = 1; i < 3; i++) {
        if (this.index + i < this.images.length) {
          this.indices.push(this.index + i);
        }
      }
      for (var i = 1; i < 3; i++) {
        if (this.index - i >= 0) {
          this.indices.unshift(this.index - i);
        }
      }
      this.displayArray = [];
      for (var i = 0; i < this.indices.length; i++) {
        this.displayArray[i] = this.images[this.indices[i]];
      }
    },
    setLoader(trigger) {
      this.$parent.loading = trigger;
    },
    reset() {
      this.setLoader(false);
      router.push("main-page-images");
    },
    selectedImage(index) {
      this.index = this.indices[index];
      this.setImages();
      this.refreshKey++;
    },
    navigate(ahead) {
      if (ahead) {
        this.index++;
      } else {
        this.index--;
      }
      this.setImages();
      this.refreshKey++;
    },
  },
};
</script>
<style scoped>
.button {
  background-color: gray;
  color: white;
  border-radius: 50%;
  outline: none;
  height: 40px;
  width: 40px;
  transition: all 0.5s;
}

.button:hover {
  background-color: black;
}
</style>
